import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Marketing / public pages
import HomePage from './pages/HomePage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';
import BusinessSignupPage from './pages/BusinessSignupPage';

// Business dashboard pages
import DashboardPage from './pages/DashboardPage';
import InvoicesPage from './pages/InvoicesPage';
import PaymentLinkPage from './pages/PaymentLinkPage';
import QRPayPage from './pages/QRPayPage';

// Space Monkey account pages
import SpaceMonkeyPage from './pages/spacemonkey/SpaceMonkeyPage';
import SpaceMonkeyPayPage from './pages/spacemonkey/SpaceMonkeyPayPage';
import SpaceMonkeyValidatePage from './pages/spacemonkey/SpaceMonkeyValidatePage';
import SpaceMonkeyDashboardPage from './pages/spacemonkey/SpaceMonkeyDashboardPage';
import SpaceMonkeySignPage from './pages/spacemonkey/SpaceMonkeySignPage';
import SpaceMonkeySettingsPage from './pages/spacemonkey/SpaceMonkeySettingsPage';

// Enforcement pages
import EnforcementPage from './pages/EnforcementPage';
import EnforcementScanPage from './pages/enforcement/EnforcementScanPage';

// Existing payment flow pages (preserved)
import ZonePage from './pages/ZonePage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentStatusPage from './pages/PaymentStatusPage';

// Admin pages (preserved)
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import AdminDashboardPage from './pages/admin/DashboardPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Marketing */}
        <Route path="/" element={<HomePage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/business-signup" element={<BusinessSignupPage />} />

        {/* Business dashboard */}
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/payment-link" element={<PaymentLinkPage />} />
        <Route path="/qr-pay" element={<QRPayPage />} />

        {/* Space Monkey account */}
        <Route path="/spacemonkey" element={<SpaceMonkeyPage />} />
        <Route path="/spacemonkey/pay" element={<SpaceMonkeyPayPage />} />
        <Route path="/spacemonkey/validate" element={<SpaceMonkeyValidatePage />} />
        <Route path="/spacemonkey/dashboard" element={<SpaceMonkeyDashboardPage />} />
        <Route path="/spacemonkey/sign" element={<SpaceMonkeySignPage />} />
        <Route path="/spacemonkey/qr-sign" element={<SpaceMonkeySignPage />} />
        <Route path="/spacemonkey/settings" element={<SpaceMonkeySettingsPage />} />

        {/* Enforcement */}
        <Route path="/enforcement" element={<EnforcementPage />} />
        <Route path="/enforcement/scan" element={<EnforcementScanPage />} />

        {/* Legacy parking payment flow (preserved) */}
        <Route path="/zone" element={<ZonePage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/payment-status/:paymentIntentId" element={<PaymentStatusPage />} />
        <Route path="/payment-status" element={<PaymentStatusPage />} />

        {/* Admin (preserved) */}
        <Route path="/admin/signin" element={<SignInPage />} />
        <Route path="/admin/signup" element={<SignUpPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
